(function () {
  'use strict';

  var drawerProductCache = {};
  var currentDrawerCart = null; // last cart rendered in the drawer (for GA4 remove)

  /* ── Init ─────────────────────────────────────────────────────────── */
  function init() {
    // Drawer events always run regardless of page type
    var closeBtn = document.getElementById('pwb-drawer-close');
    var overlay  = document.getElementById('pwb-cart-overlay');
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    if (overlay)  overlay.addEventListener('click', closeCartDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });

    // Drawer item interactions (qty, selling plan, remove) via delegation
    var drawerItemsEl = document.getElementById('pwb-drawer-items');
    if (drawerItemsEl) {
      drawerItemsEl.addEventListener('click', onDrawerClick);
      drawerItemsEl.addEventListener('change', onDrawerChange);
    }

    // Drawer footer checkout link → GA4 begin_checkout before navigating
    var drawerEl = document.getElementById('pwb-cart-drawer');
    if (drawerEl) drawerEl.addEventListener('click', onDrawerCheckoutClick);

    // Header cart icon → open drawer instead of hover dropdown
    //var cartHeadingBtn = document.getElementById('pwb-header-cart-btn');
    var cartHeadingBtn = document.getElementById('cart_block');
    if (cartHeadingBtn) {
      cartHeadingBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showDrawerLoading();
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            refreshMiniCartBadge(cart);
            renderCartDrawer(cart);
          })
          .catch(function () { closeCartDrawer(); });
      });
    }

    // ATC forms (product + collection pages, incl. product-item2 list view)
    var forms = document.querySelectorAll(
      'form[data-type="add-to-cart-form"], form.card-information[action^="/cart/add"]'
    );
    if (!forms.length) {
      console.warn('[pwb-atc] No add-to-cart forms found on this page.');
    }
    forms.forEach(function (form) {
      console.log('[pwb-atc] Attaching submit listener to', form.id || form);
      form.addEventListener('submit', handleAddToCart);
    });

    // Sticky bar form (.sticky_form) — intercept its submit button
    var stickyForm = document.querySelector('form.sticky_form');
    if (stickyForm) {
      var stickyBtn = stickyForm.querySelector('button.add-to-cart, button[type="submit"]');
      var handleSticky = function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        addToCartFromForm(stickyForm, stickyBtn);
      };
      if (stickyBtn) stickyBtn.addEventListener('click', handleSticky);
      stickyForm.addEventListener('submit', handleSticky);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── ATC form submit ──────────────────────────────────────────────── */
  function handleAddToCart(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var submitBtn = form.querySelector('button[type="submit"][name="add"]')
                 || form.querySelector('button[type="submit"].add-to-cart');
    addToCartFromForm(form, submitBtn);
  }

  function addToCartFromForm(form, submitBtn) {
    var variantInput = form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');
    if (!variantInput) {
      console.error('[pwb-atc] Could not find id input in form.');
      return;
    }
    var variantId = variantInput.value;

    var qtyEl = form.querySelector('[name="quantity"]');
    var quantity = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;

    var isSubscription = !!document.querySelector('.selling-plan-options input#subscription:checked');
    var sellingPlan = null;
    if (isSubscription) {
      var activeSelect = form.querySelector('select[name="selling_plan"].active:not([disabled])');
      if (activeSelect) sellingPlan = activeSelect.value;
    }

    var body = { id: variantId, quantity: quantity };
    if (sellingPlan) body.selling_plan = sellingPlan;

    var discountInput = form.querySelector('input[name="properties[Subscription Discount]"]:not([disabled])');
    if (discountInput && discountInput.value) {
      body.properties = { 'Subscription Discount': discountInput.value };
    }

    console.log('[pwb-atc] Adding to cart:', body);

    if (submitBtn) { submitBtn.disabled = true; submitBtn.classList.add('loading'); }
    hideError(form);
    showDrawerLoading();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) {
          throw new Error(d.description || d.message || 'Could not add item to cart.');
        });
        return res.json();
      })
      .then(function (added) {
        // GA4 add_to_cart: report the amount just added (not the new line total).
        // Translated to a dataLayer push by the listener in ga4_generic.liquid.
        dispatchCartEvent('pwb:add-to-cart', { item: added, quantity: quantity });
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        console.log('[pwb-atc] Cart updated, item_count:', cart.item_count);
        refreshMiniCartBadge(cart);
        renderCartDrawer(cart);
      })
      .catch(function (err) {
        console.error('[pwb-atc] Error:', err.message);
        closeCartDrawer();
        showError(form, err.message || 'Something went wrong. Please try again.');
      })
      .finally(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.classList.remove('loading'); }
      });
  }

  /* ── Drawer loading state ─────────────────────────────────────────── */
  function showDrawerLoading() {
    var loading = document.getElementById('pwb-drawer-loading');
    var items   = document.getElementById('pwb-drawer-items');
    var empty   = document.getElementById('pwb-drawer-empty');
    var footer  = document.getElementById('pwb-drawer-footer');
    if (loading) loading.style.display = 'flex';
    if (items)   { items.innerHTML = ''; items.style.display = 'none'; }
    if (empty)   empty.classList.remove('is-visible');
    if (footer)  footer.classList.remove('is-visible');
    openCartDrawer();
  }

  /* ── Render drawer items ──────────────────────────────────────────── */
  function renderCartDrawer(cart) {
    currentDrawerCart = cart; // snapshot for GA4 remove lookups
    window.pwbLastCart = cart; // shared snapshot for GA4 begin_checkout
    var loading  = document.getElementById('pwb-drawer-loading');
    var itemsEl  = document.getElementById('pwb-drawer-items');
    var empty    = document.getElementById('pwb-drawer-empty');
    var footer   = document.getElementById('pwb-drawer-footer');
    var count    = document.getElementById('pwb-drawer-count');
    var subtotal = document.getElementById('pwb-drawer-subtotal');

    if (loading) loading.style.display = 'none';
    if (count) count.textContent = cart.item_count > 0 ? cart.item_count : '';

    if (!cart.items || cart.items.length === 0) {
      if (itemsEl)  { itemsEl.innerHTML = ''; itemsEl.style.display = 'none'; }
      if (empty)    empty.classList.add('is-visible');
      if (footer)   footer.classList.remove('is-visible');
      return;
    }

    var html = cart.items.map(function (item, index) {
      var variantText = item.variant_title && item.variant_title !== 'Default Title'
        ? '<span class="pwb-drawer__item-variant-title">' + esc(item.variant_title) + '</span>'
        : '';
      var discountText;
      if (item.selling_plan_allocation) {
        // Subscribed line: show the subscription discount instead of the
        // cart-level discount allocations.
        var subPct = subscriptionDiscountPercent(item);
        discountText = '<span class="pwb-drawer__item-discount">Subscription Discount: '
          + esc(subPct) + '</span>';
      } else {
        discountText = (item.line_level_discount_allocations || []).map(function (alloc) {
          return '<span class="pwb-drawer__item-discount">'
            + esc(alloc.discount_application.title) + ' (−' + formatMoney(alloc.amount) + ')'
            + '</span>';
        }).join('');
      }
      var variantLine = (variantText || discountText)
        ? '<div class="pwb-drawer__item-variant">' + variantText + discountText + '</div>'
        : '';

      // Selling plan area
      var planWrap;
      if (item.selling_plan_allocation) {
        // Subscribed: show "Delivery:" label + select immediately
        planWrap = '<div class="pwb-drawer__item-plan-wrap" style="display:none">'
          + '<span class="pwb-drawer__plan-label">Delivery:</span>'
          + '<select class="pwb-drawer__item-plan-select" aria-label="Delivery frequency">'
          + '<option value="' + item.selling_plan_allocation.selling_plan.id + '" selected>'
          + esc(item.selling_plan_allocation.selling_plan.name)
          + '</option>'
          + '</select>'
          + '</div>';
      } else {
        // One-time: show subscribe button; label + select hidden until button clicked
        planWrap = '<div class="pwb-drawer__item-plan-wrap" style="display:none">'
          + '<button type="button" class="pwb-drawer__subscribe-btn" data-action="drawer-show-plans">'
          + '<svg width="9" height="12" viewBox="0 0 9 12" fill="currentColor" aria-hidden="true" style="flex-shrink:0">'
          + '<path fill-rule="evenodd" clip-rule="evenodd" d="M4.36364 4.36364V2.72727C2.55818 2.72727 1.09091 4.19455 1.09091 6C1.09091 6.55091 1.22727 7.07455 1.47273 7.52727L0.676364 8.32364C0.250909 7.65273 0 6.85636 0 6C0 3.58909 1.95273 1.63636 4.36364 1.63636V0L6.54545 2.18182L4.36364 4.36364ZM7.25461 4.47276L8.05098 3.67639C8.47643 4.3473 8.72734 5.14366 8.72734 6.00003C8.72734 8.41094 6.77461 10.3637 4.3637 10.3637V12L2.18188 9.81821L4.3637 7.63639V9.27276C6.16916 9.27276 7.63643 7.80548 7.63643 6.00003C7.63643 5.44912 7.49461 4.93094 7.25461 4.47276Z" fill="currentColor"/>'
          + '</svg>'
          + 'Click to Save 15% with a Subscription'
          + '</button>'
          + '<span class="pwb-drawer__plan-label" style="display:none">Delivery:</span>'
          + '<select class="pwb-drawer__item-plan-select" aria-label="Delivery frequency" style="display:none">'
          + '<option value="" selected>One-time purchase</option>'
          + '</select>'
          + '</div>';
      }

      var linePrice = formatMoney(item.line_price);
      var imageSrc  = item.image ? esc(item.image) : '';
      var planAttr  = item.selling_plan_allocation
        ? ' data-selling-plan="' + item.selling_plan_allocation.selling_plan.id + '"'
        : '';

      return '<div class="pwb-drawer__item"'
        + ' data-key="' + esc(item.key) + '"'
        + ' data-line="' + (index + 1) + '"'
        + ' data-variant-id="' + item.variant_id + '"'
        + ' data-product-handle="' + esc(item.handle || '') + '"'
        + planAttr
        + ' style="animation-delay:' + (index * 0.04) + 's">'

        + '<div class="pwb-drawer__item-image">'
        + (imageSrc ? '<img src="' + imageSrc + '" alt="' + esc(item.product_title) + '" loading="lazy" />' : '')
        + '</div>'

        + '<div class="pwb-drawer__item-body">'
        + '<div class="pwb-drawer__item-title">' + esc(item.product_title) + '</div>'
        + variantLine
        + planWrap
        + '<div class="pwb-drawer__item-meta">'
        + '<div class="pwb-drawer__qty-stepper">'
        + '<button type="button" class="pwb-drawer__qty-btn" data-action="drawer-qty-minus" aria-label="Decrease">&minus;</button>'
        + '<span class="pwb-drawer__qty-val">' + item.quantity + '</span>'
        + '<button type="button" class="pwb-drawer__qty-btn" data-action="drawer-qty-plus" aria-label="Increase">+</button>'
        + '</div>'
        + '<button class="pwb-drawer__item-remove" data-action="remove" aria-label="Remove ' + esc(item.product_title) + '">'
        + '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">'
        + '<polyline points="3 6 5 6 21 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
        + '<path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
        + '<path d="M10 11v6M14 11v6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
        + '<path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
        + '</svg>'
        + '</button>'
        + '<span class="pwb-drawer__item-price">' + linePrice + '</span>'
        + '</div>'
        + '</div>'
        + '</div>';
    }).join('');

    if (itemsEl) {
      itemsEl.innerHTML = html;
      itemsEl.style.display = 'block';
    }

    if (empty)    empty.classList.remove('is-visible');
    if (footer)   footer.classList.add('is-visible');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    // Fetch + populate selling plan selects for all items
    fetchPlansForAllDrawerItems();
  }

  /* ── Drawer event handlers ────────────────────────────────────────── */
  function onDrawerClick(e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var action = btn.dataset.action;
    var itemEl = btn.closest('.pwb-drawer__item');

    if (action === 'drawer-qty-minus' || action === 'drawer-qty-plus') {
      if (!itemEl) return;
      var qtyEl = itemEl.querySelector('.pwb-drawer__qty-val');
      var currentQty = parseInt(qtyEl ? qtyEl.textContent : '1', 10);
      var delta = action === 'drawer-qty-minus' ? -1 : 1;
      var newQty = Math.max(0, currentQty + delta);
      if (qtyEl) qtyEl.textContent = newQty;
      drawerChangeItem(itemEl, { quantity: newQty });

    } else if (action === 'drawer-show-plans') {
      // Reveal the "Delivery:" label and select, hide the subscribe button
      var wrap = btn.closest('.pwb-drawer__item-plan-wrap');
      if (wrap) {
        btn.style.display = 'none';
        var label = wrap.querySelector('.pwb-drawer__plan-label');
        var sel   = wrap.querySelector('.pwb-drawer__item-plan-select');
        if (label) label.style.display = 'inline';
        if (sel) {
          sel.style.display = '';
          // Open the native dropdown immediately so the customer can just
          // pick a frequency. showPicker() requires the current user gesture
          // (this click) and no-ops on browsers that don't support it.
          sel.focus();
          try { sel.showPicker(); } catch (e) {}
        }
      }

    } else if (action === 'remove') {
      if (!itemEl) return;
      dispatchRemoveForItem(itemEl);
      drawerChangeItem(itemEl, { quantity: 0 });
    }
  }

  // GA4 remove_from_cart: emit before the item leaves the cart, resolving its
  // full line-item data from the last rendered cart snapshot.
  function dispatchRemoveForItem(itemEl) {
    if (!currentDrawerCart || !currentDrawerCart.items) return;
    var key = itemEl.dataset.key;
    var line = parseInt(itemEl.dataset.line, 10);
    var item = key
      ? currentDrawerCart.items.filter(function (it) { return it.key === key; })[0]
      : null;
    if (!item && line) item = currentDrawerCart.items[line - 1];
    if (item) dispatchCartEvent('pwb:remove-from-cart', { item: item });
  }

  function dispatchCartEvent(name, detail) {
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); }
    catch (e) { /* CustomEvent unsupported — skip analytics, never block the cart */ }
  }

  // GA4 begin_checkout: the drawer footer checkout link is a plain <a> to
  // /checkout, so hold the navigation just long enough for GTM to pick up the
  // dataLayer push (ga4_generic.liquid listens for `pwb:begin-checkout`).
  function onDrawerCheckoutClick(e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var link = target.closest('[data-pwb-checkout]');
    if (!link) return;

    e.preventDefault();
    var href = link.getAttribute('href') || '/checkout?skip_shop_pay=true';
    var go = function () { window.location = href; };

    // The drawer can only be shown after a /cart.js fetch, so the snapshot is
    // normally present and current; fall back to a fetch just in case.
    if (currentDrawerCart && currentDrawerCart.items && currentDrawerCart.items.length) {
      dispatchCartEvent('pwb:begin-checkout', { cart: currentDrawerCart });
      setTimeout(go, 150);
      return;
    }

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        currentDrawerCart = cart;
        window.pwbLastCart = cart;
        dispatchCartEvent('pwb:begin-checkout', { cart: cart });
        setTimeout(go, 150);
      })
      .catch(go);
  }

  function onDrawerChange(e) {
    var el = e.target;
    if (!el.classList.contains('pwb-drawer__item-plan-select')) return;
    var itemEl = el.closest('.pwb-drawer__item');
    if (!itemEl) return;
    var planVal = el.value;
    drawerChangeItem(itemEl, { selling_plan: planVal === '' ? '' : parseInt(planVal, 10) });
  }

  /* ── Drawer cart API ──────────────────────────────────────────────── */
  function drawerChangeItem(itemEl, changes) {
    var line = parseInt(itemEl.dataset.line, 10);
    if (!line) { console.error('[pwb-drawer] item missing data-line'); return; }

    itemEl.style.opacity = '0.45';
    itemEl.style.pointerEvents = 'none';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({ line: line }, changes))
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || d.message || 'Error'); });
        return res.json();
      })
      .then(function (cart) {
        refreshMiniCartBadge(cart);
        renderCartDrawer(cart); // full re-render keeps data-line accurate
      })
      .catch(function (err) {
        console.error('[pwb-drawer]', err);
        itemEl.style.opacity = '';
        itemEl.style.pointerEvents = '';
      });
  }

  /* ── Drawer selling plan selects ──────────────────────────────────── */
  function fetchPlansForAllDrawerItems() {
    var fetching = {};
    document.querySelectorAll('#pwb-drawer-items .pwb-drawer__item[data-product-handle]').forEach(function (itemEl) {
      var handle = itemEl.dataset.productHandle;
      if (!handle) return;

      if (drawerProductCache[handle] !== undefined) {
        populateDrawerPlanSelect(itemEl, drawerProductCache[handle]);
        return;
      }
      if (fetching[handle]) return; // single fetch per product per render
      fetching[handle] = true;

      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          drawerProductCache[handle] = product;
          document.querySelectorAll(
            '#pwb-drawer-items .pwb-drawer__item[data-product-handle="' + handle + '"]'
          ).forEach(function (el) {
            populateDrawerPlanSelect(el, product);
          });
        })
        .catch(function () {
          drawerProductCache[handle] = { selling_plan_groups: [], variants: [] };
        });
    });
  }

  function populateDrawerPlanSelect(itemEl, product) {
    var select = itemEl.querySelector('.pwb-drawer__item-plan-select');
    var wrap   = itemEl.querySelector('.pwb-drawer__item-plan-wrap');
    if (!select || !wrap) return;

    var variantId   = parseInt(itemEl.dataset.variantId, 10);
    var currentPlan = itemEl.dataset.sellingPlan || '';
    var groups = product.selling_plan_groups || [];

    // Collect plan IDs valid for this specific variant, plus the variant price
    // (needed to compute the "Save X%" label for each subscription group).
    var validPlanIds = new Set();
    var variantPrice = 0;
    (product.variants || []).forEach(function (v) {
      if (v.id === variantId) {
        variantPrice = v.price;
        (v.selling_plan_allocations || []).forEach(function (a) {
          validPlanIds.add(a.selling_plan_id);
        });
      }
    });

    var hasPlans = false;
    var options =
      '<optgroup label="One Time Purchase">' +
        '<option value=""' + (currentPlan === '' ? ' selected' : '') + '>One-time</option>' +
      '</optgroup>';

    groups.forEach(function (group) {
      var plans = (group.selling_plans || []).filter(function (plan) {
        return validPlanIds.size === 0 || validPlanIds.has(plan.id);
      });
      if (!plans.length) return;
      hasPlans = true;

      var save = planDiscountPercent(plans[0], variantPrice);
      var label = esc(group.name) + (save ? ' (Save ' + save + ')' : '');

      var groupOptions = '';
      plans.forEach(function (plan) {
        var sel = String(plan.id) === String(currentPlan) ? ' selected' : '';
        groupOptions += '<option value="' + plan.id + '"' + sel + '>' + esc(plan.name) + '</option>';
      });

      options += '<optgroup label="' + label + '">' + groupOptions + '</optgroup>';
    });

    select.innerHTML = options;
    // Show the whole plan wrap only if this variant has eligible selling plans
    wrap.style.display = hasPlans ? '' : 'none';
  }

  /* ── Open / close drawer ──────────────────────────────────────────── */
  function openCartDrawer() {
    var drawer  = document.getElementById('pwb-cart-drawer');
    var overlay = document.getElementById('pwb-cart-overlay');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var drawer  = document.getElementById('pwb-cart-drawer');
    var overlay = document.getElementById('pwb-cart-overlay');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ── Refresh hover mini-cart badge + items ────────────────────────── */
  function refreshMiniCartBadge(cart) {
    document.querySelectorAll('.pwb_cart_mark, .pwb_sticky_cart_mark').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    var stickyCart = document.getElementById('pwb_sticky_cart');
    if (stickyCart) stickyCart.style.display = cart.item_count > 0 ? 'block' : 'none';

    var wrapper = document.querySelector('#cart_content .cart_content_ajax');
    if (!wrapper) return;

    if (!cart.items || cart.items.length === 0) {
      wrapper.innerHTML = '<div class="empty">Empty</div>';
      return;
    }

    var rows = cart.items.map(function (item) {
      var variantLabel = item.variant_title && item.variant_title !== 'Default Title'
        ? '<small>' + esc(item.variant_title) + '</small>' : '';
      return '<tr id="mini_item_' + item.variant_id + '">'
        + '<td class="image"><a href="' + esc(item.url) + '"><img src="' + esc(item.image) + '" alt="' + esc(item.product_title) + '" /></a></td>'
        + '<td class="name"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>'
        + '<div>' + variantLabel + '</div>'
        + '<p><span class="quantity">' + item.quantity + ' &times; </span>'
        + '<span class="total"><span class="money">' + formatMoney(item.price) + '</span></span></p></td>'
        + '<td class="remove"><a href="/cart/change?line=' + esc(item.key) + '&quantity=0" data-id="' + item.variant_id + '" title="Remove">&times;</a></td>'
        + '</tr>';
    }).join('');

    wrapper.innerHTML =
      '<div class="mini-cart-info"><table><tbody>' + rows + '</tbody></table></div>'
      + '<div class="mini-cart-total"><table><tbody>'
      + '<tr><td><b>Subtotal:</b></td><td class="right"><span class="money">' + formatMoney(cart.total_price) + '</span></td></tr>'
      + '</tbody></table></div>'
      + '<div class="checkout cart__condition__wrapper">'
      + '<a href="/cart" class="button btn-default">View Shopping Bag</a>'
      + '<a href="/checkout?skip_shop_pay=true" class="button checkout-button">Checkout</a>'
      + '</div>';
  }

  /* ── Error helpers ────────────────────────────────────────────────── */
  function showError(form, msg) {
    var el = form.querySelector('.pwb-atc-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'pwb-atc-error';
      var btns = form.querySelector('.product-form__buttons');
      if (btns) btns.insertAdjacentElement('afterend', el);
      else form.appendChild(el);
    }
    el.textContent = msg;
    el.style.display = 'block';
  }

  function hideError(form) {
    var el = form.querySelector('.pwb-atc-error');
    if (el) el.style.display = 'none';
  }

  /* ── Utilities ────────────────────────────────────────────────────── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Subscription discount for a subscribed line, as a "12%"-style string.
  // Prefers the 'Subscription Discount' line-item property this theme writes;
  // falls back to computing it from the selling plan allocation's prices.
  function subscriptionDiscountPercent(item) {
    if (item.properties && item.properties['Subscription Discount']) {
      return String(item.properties['Subscription Discount']);
    }
    var alloc = item.selling_plan_allocation;
    if (alloc && alloc.compare_at_price && alloc.price && alloc.compare_at_price > alloc.price) {
      return Math.round((alloc.compare_at_price - alloc.price) / alloc.compare_at_price * 100) + '%';
    }
    return '';
  }

  // Returns a "12%"-style savings string for a selling plan given the variant
  // price, or '' if it can't be computed.
  function planDiscountPercent(plan, price) {
    var adj = plan && plan.price_adjustments && plan.price_adjustments[0];
    if (!adj || !price) return '';
    switch (adj.value_type) {
      case 'percentage':
        return adj.value + '%';
      case 'fixed_amount':
        return Math.round((adj.value / price) * 100) + '%';
      case 'price':
        return Math.round(((price - adj.value) / price) * 100) + '%';
      default:
        return '';
    }
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
})();
